<div class="justification-block">
  <p class="name">{{ isEdit ? "Justification" : vendor?.Name || "" }}</p>
  <textarea
    [ngClass]="{ 'input-error': isError }"
    maxlength="1500"
    matInput
    placeholder="e.g. Buying mechanical parts for project alpha"
    [(ngModel)]="justificationControl"
    class="justification-input"
    (change)="justificationChange($event)"
  ></textarea>
  <div class="hint">{{ justificationControl.length }}/1500</div>
</div>
